module.exports = "/assets/b267ba25893ebf242a267a91902be902.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/FQ.png
// module id = 1378
// module chunks = 0